export const calculateAge = function (birthDay: Date) {
	// birthday is a date
	const ageDifMs = Date.now() - birthDay.getTime();
	const ageDate = new Date(ageDifMs); // miliseconds from epoch
	return Math.abs(ageDate.getUTCFullYear() - 1970);
};

export const calculateAgeGroup = function (age: number) {
	if (age >= 18 && age <= 39) {
		return "18-39";
	} else if (age >= 40 && age <= 59) {
		return "40-59";
	} else if (age >= 60 && age <= 64) {
		return "60-64";
	} else return "65+";
};
